import get from 'lodash/get';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/switchMap';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {
  assignAssetToModel,
  assignOrganizationToModel,
  assignProjectToModel,
  selectedOrganization,
  selectedProject,
  selectedAsset,
  assignAssetProjectToModel, assignOrganizationProfileToModel,
} from '../actions';
import {assetProjectReduxItem} from '../redux/assetProjectReduxItem';
import {assetReduxItem} from '../redux/assetReduxItem';
import {organizationReduxItem} from '../redux/organizationReduxItem';
import {orgProfileReduxItem} from '../redux/orgProfileReduxItem';
import {projectReduxItem} from '../redux/projectReduxItem';


export const epics = [
  onAssetProjectSelected,
  onAssetSelected,
  onOrganizationSelected,
  onOrgProfileSelected,
  onProjectSelected,
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @return {Observable.<ReduxAction>}
 */
function onAssetProjectSelected(action$, store) {
  return action$.ofType(assignAssetProjectToModel.TYPE)
    .map(action => getId(action.payload.assetProject))
    .switchMap(mapToAction(assetProjectReduxItem, store));
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @return {Observable.<ReduxAction>}
 */
function onOrganizationSelected(action$, store) {
  return buildObserveEpic(
    selectedOrganization,
    assignOrganizationToModel,
    'organization',
    organizationReduxItem,
  )(action$, store);
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @return {Observable.<ReduxAction>}
 */
function onOrgProfileSelected(action$, store) {
  return action$.ofType(assignOrganizationProfileToModel.TYPE)
    .map(action => getId(action.payload.orgProfile))
    .switchMap(mapToAction(orgProfileReduxItem, store));
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @return {Observable.<ReduxAction>}
 */
function onProjectSelected(action$, store) {
  return buildObserveEpic(
    selectedProject,
    assignProjectToModel,
    'project',
    projectReduxItem,
  )(action$, store);
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @return {Observable.<ReduxAction>}
 */
function onAssetSelected(action$, store) {
  return buildObserveEpic(
    selectedAsset,
    assignAssetToModel,
    'asset',
    assetReduxItem,
  )(action$, store);
}

/**
 * @param {Function|ReduxActionCreator} selectAction
 * @param {Function|ReduxActionCreator} assignAction
 * @param {String} prop
 * @param {ReduxItem} reduxItem
 * @return {function(*, *): Observable<ReduxAction>}
 */
function buildObserveEpic(selectAction, assignAction, prop, reduxItem) {
  return (action$, store) => action$.ofType(selectAction.TYPE, assignAction.TYPE)
    .map(getIdFromAction(selectAction, prop))
    .switchMap(mapToAction(reduxItem, store));
}

/**
 * @param {Function|ReduxActionCreator} selectAction
 * @param {String} prop
 * @return {function(ReduxAction): String}
 */
function getIdFromAction(selectAction, prop) {
  return action => {
    if (action.type === selectAction.TYPE) {
      return action.payload.id;
    } else {
      return getId(get(action, `payload.${prop}`));
    }
  };
}

/**
 * @param {ReduxItem} reduxItem
 * @param {Store} store
 * @return {function(String): Observable<ReduxAction>}
 */
function mapToAction(reduxItem, store) {
  return id => {
    const itemState = reduxItem.options.getState(store.getState());

    if (id) {
      if (itemState.init) {
        if (itemState.id === id) {
          return Observable.empty();
        } else {
          return Observable
            .merge(
              Observable.of(reduxItem.actions.destroyItem({}, {id: itemState.id})),
              Observable.timer(10).mapTo(reduxItem.actions.initItem({id})),
            );
        }
      } else {
        return Observable.of(reduxItem.actions.initItem({id}));
      }

    } else {
      if (itemState.init) {
        return Observable.of(reduxItem.actions.destroyItem({}, {id: itemState.id}));
      } else {
        return Observable.empty();
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/app/model/epics/reduxItemModel.js